import p2 from "@/assets/p2.png";
import p3 from "@/assets/p3.png";
import p4 from "@/assets/p4.png";
import p5 from "@/assets/p5.png";

import banner1 from "@/assets/i1.png";
import banner2 from "@/assets/i2.png";
import banner3 from "@/assets/i3.png";
import banner4 from "@/assets/i4.png";

import brand1 from "@/assets/brand1.svg";
import brand2 from "@/assets/brand2.png";
import brand3 from "@/assets/brand3.png";
import brand4 from "@/assets/brand4.png";
import brand5 from "@/assets/brand5.png";
import brand6 from "@/assets/brand6.png";
import brand7 from "@/assets/brand7.png";
import giftbox from "@/assets/giftbox.png";

export const placeholderImage = "/placeholder.png";

export const baseApi = process.env.NEXT_PUBLIC_BASE_API || "";

export const cartCookieKey =
  process.env.NEXT_PUBLIC_COOKIE_KEY || "cart-gng-cookie";

const welcomePopupKey =
  process.env.NEXT_PUBLIC_WELCOME_POPUP_CLOSE_KEY || "gng-welcome-popup-closed";

export const envs = {
  homePageUrl: process.env.NEXT_PUBLIC_HOME_PAGE_URL || "",
  domain: process.env.NEXT_PUBLIC_DOMAIN_URL || "",
  cookieKey: process.env.NEXT_PUBLIC_COOKIE_KEY || "",
  adminTokenKey: process.env.NEXT_PUBLIC_ADMIN_TOKEN_KEY || "",

  welcomeCookieKey: process.env.NEXT_PUBLIC_WELCOME_COOKIE_KEY || "",
  lvpCookieKey: process.env.NEXT_PUBLIC_LAST_VISITED_PRODUCTS_COOKIE_KEY || "",

  s3Bucket: process.env.NEXT_PUBLIC_S3_BASE_URL || "",
  s3BucketMediu: process.env.NEXT_PUBLIC_S3_MEDIA_URL || "",
  cdnLink: process.env.NEXT_PUBLIC_BASE_CDN,

  mapUrl: process.env.NEXT_PUBLIC_MAP_API_URL || "",
  mapApiKey: process.env.NEXT_PUBLIC_MAP_API_KEY || "",
  baseApiUrl: process.env.NEXT_PUBLIC_BASE_API || "",

  welcomePupupCloseKey: welcomePopupKey,
  welcomePopupTimeKey: welcomePopupKey + "-time",
  welcomePopupCountKey: welcomePopupKey + "-count",
  welcomePopupHashKey: welcomePopupKey + "-hash",
};

export const routes = {
  home: "/",
  login: "/auth/login",
  register: "/auth/register",
  otpLogin: "/auth/login",
  otpRegester: "/auth/register",
  // otpLogin: "/auth/otp-login",
  // otpRegester: "/auth/otp-register",
  category: "/category/",
  brand: "/brand/",
  product: "/product/",
  blogs: "/blogs/",
  search: "/search/",
  storeLocator: "/store-locator",

  cart: "/cart",
  checkout: "/checkout",
  user: "/user",
  address: "/user/address",
  faq: "/user/faq",
  orders: "/user/orders",
  orderDetails: "/user/order/",
  reviews: "/user/reviews",
  rewardPoints: "/user/reward-points",

  orderSuccess: "order-success",
};

export const categoryShowChildIds = [14, 21, 61, 102]; // Accessories, Camera/Gimbal, Fitness & Wearable, Video Games

// export const countryId = 1;
export const countryId = 1;

export const currentPageQuery = "currentPage";

export const phonePattern = /^(?:(?:\+|00|)88|01)?\d{11}$/;

export const mapMarkerIcon =
  "https://maps.gstatic.com/mapfiles/transparent.png";

export const cartButtonId = "cart-button-header-92834";
export const productImageId = "product-main-image-0985";

// add or remove campaign buttons from menu
// Header Component L:650 (for desktop)
// MenuBar Component L:171 (for mobile)

export const campaign = {
  title: " Offers",
  color: "#F26E21",
};

export const onlineOnly = {
  title: "Online Exclusive",
  color: "#7AB968",
};

export const pdImage1 =
  "https://s3-alpha-sig.figma.com/img/0117/0536/f553e0f0395b08537e66c2a111a4dded?Expires=1696809600&Signature=HOja5yvT37zA5g0ZKJYai7FaEsJuv8ASicUPHh3ewJZxYJkcnZKAimf5kiStn25JGXrkR5aVEkavFU~X~aIFfOSBwZXc1r~c3PljiixZmFDvre8gCQezQJaYUMVfLPmT8ViLZisvn6TdGCgkIHCNsj7y-nhP42DQoSQOwC9CpXjoZKWFQCVXC56cKIkjirE-ksSRuGoECCQiLrIcfo321OoRh75NZspgZOstUgttxw7PiN7dKDkr0mXSytEtkQ2jkp2k1pQS6MSJ9bE0iAnWGicBEhRxz1kzNvxUmeq5ZsmN8Qh2FzUUwqs6xfumCAIB7SeiOxjWJJdVB2We9Uh3XA__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4";
export const pdImage2 =
  "https://s3-alpha-sig.figma.com/img/3cc6/9c9e/2d0b573cfede8c13627df79a1b4d1f29?Expires=1696809600&Signature=PHlgfSN8ecIqT69439C1jGzxZ9Qfa1rdlWi0Mz2BCy-pUB7Dv2Y9-BarQHe5VzfjemH470D~50m3GbKlo8qecbGQLKfSqGvWOCEd8~GrIi0M02dcPUtxy0cdki63dfst~JgVEIQfu7DMUqRY5q1o6RjdczLhLkmZMdCI3FZ4ibuVCkU1iMsO6JIpayJjwtLTWsMMEEAuREfGgouDirjYeTBweT7j7jNb07nIQ2EsGyap7F8bmBL5DrWWblQkpRNhMBe2fS0O~rhs~TasnmQvEsWcP~iPEL~7tr40fv65okOknCnbs~cmYvXwCKeRzHH7qxk-SWaniFnkhOzoDm5I~Q__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4";
export const pdImage3 =
  "https://s3-alpha-sig.figma.com/img/4dce/757e/28bc03a8f0971460bb23460818c662de?Expires=1696809600&Signature=bHODiPsse3UVB6yUTjO4kgGQynJhN3Wi~DNo-ElmWVwJxAobheMHBk88iIMuPvPdrg3nqh8nGHeSOCgLN-viNmGLydxRyKxy~eYtyJXtR7SwaYPFvEUgsRfOYOOmiMulLWIvRXjSOaQNL9SlEQkXPlh5TBct3PxGaw-OeJoI0qdPHKS~b5GSjh7tXxt0lrJkNC-XQVJelLqVhz0IaYd1t75ky2cn4e~vX7sMYCCdN8y2xGqxAH2FcokRqerXUOGYZ~KB7~Igh-r68u8J1ijQQPe4WdHIcEVc109iMcCo08HyEBoe~9hpEJTxcYLemeC2RASXarMuChaMnjWo8c9ReQ__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4";
export const pdImage4 =
  "https://s3-alpha-sig.figma.com/img/abd4/8d4a/97392e6873cee278e4fbaa31e716ddd9?Expires=1696809600&Signature=MLbAGY0M7BycHtlrSW5H7gOrYGNKLBBVifgLpz7sHcZXAbC1gldon~xPnHRgSVV-FM-~L99cffx8VzZrmsVspD4MFrGKnf2G~-JOnKtS0DCoGOvocAV~OIWN6gg-zGsVDkZoIxC3KZSbbTptF8A7n-yL36dS1rBMasY8Um1BHZYhQ1RFYUvfx6kDFpnacrmWJiXkyfIPXswi5D0rGpAUgMPrI7a1bm1CQ0Op-feccDUGgK2R8MlzCDbQnrUqjC6wr41xcPLlmL74UeqDLiFMaweEpi8hpY39TSYn52~wbZjD614FVI3gALOIIOzFSEihjxrC29dEJi0ux9TYGdwEYg__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4";

export const appleBrand =
  "https://s3-alpha-sig.figma.com/img/5467/9764/92ba1e8267a364fbd9a4ab8dcc1d29a7?Expires=1696809600&Signature=l6fmt8UUlZgrV9jaWbCIb006jaBQsu0dGtj3ZdGs2JswIZjztuHn~BfZ9vrDoe~aLyx5ZKETPNMmb~Sv5l0Ski09rzDgtc~65fhON9fzQwX9Bkgl56SR1hty4r4XHljpYws1AnZ19UiN9mgMgk7nnhDT79899~IVIkSp~YVebsNmb3oO3PpgmriJod90q6JrdMnKJo0kVCYuyMLRHsU8WYoWpus03BK18QtXyw3Wvcx58oQjEC71eCoZklQTQf16elvUnvRoWayRMosB1V0ntZ~MUbtjK0c1KW5c2hv6aSaThcwD0z1Eb61pLT-9EZiX8QdlT-07hTIpTLedQLuXFw__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4";

export const bkashPng =
  "https://s3-alpha-sig.figma.com/img/f9cf/8572/e6732d8b332d0a890d647f425523fe41?Expires=1698624000&Signature=JlDr9VnCZcdHmaM2nkbjeLVIQizn233~V4UZ3ZxJfCEaUP1B2MyiDZQFQe2WKSDibEOwYM1XeTQk9VTZzAnKq-M2Zd1qZsHhfPzCEGpkUIPhLKJHeKUqaMWdICe43gYSm11S-aKBwafGFNDfoG9ay1s6StZ-H3WyEIfBSvL7~rocGtaeoaA0d1TEvtq2qNfdguNIr5od2UAoHRkOZ2c3378eFR5OWb9daSyzdgK6in-E3lDebZFA-71iDF6xXsDaUzcS3axLSZx0a8DrkDxsEfW33RQw2JcJyUWdWrO291ZQWB6G930m9pUMwsaTiGXF-Zkd5w9GdIU5nwgWjW9pEg__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4";
export const nagadPng =
  "https://s3-alpha-sig.figma.com/img/397e/ee13/5dd25841b64a9e3f00aa14a779485b0c?Expires=1698624000&Signature=Ny5BHVGF1ya9AYHh1GB25PNRUlqYcBDEBGEq6eSpoqBVPr0IucEaPBAXRm0uxM18k49Uf4oEQqwotYJgOYxZKwDl1Wx9JYxvupOkB7hsWUcpxwSH74gSDIS5-JHDjrSR66C~QfjT9o6Xc9D7V8vlVVA4p8nLQKsCacHm3dz3cOIi4im2NkUOTaqHc75jKOjKRWLt-1pf9WfF4oLE3nPwtjgkaDPZ1F86v~csteQpiX8~fZd0E9iJD3G~5ZXsXEkbx3Yp04~TVzkesGXFv-mcK7flSSh8wFRNsg-~5wPMrEBi0wvi3ZhGwcNAnWStHSAWgnDkT7OkyQ4GymrINC7H1w__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4";
export const upayPng =
  "https://s3-alpha-sig.figma.com/img/83f9/ec84/313f2744534da6e5c254de774b474486?Expires=1698624000&Signature=C0SPpzj46fOP7778gmcU2W-IFC2EF8eQQz7hT-hgFClaw-goMpPE9TVrQBhDhkbpPDlJkFlRtu1ggMUTF6Qm-5XDy0Xfkiuq93YF1VaKmg7ewzQUaxRuRLIAJ6Z7kpQ53PKouMT03DJMVWC2ln5KGZZGM8Z5ufZdn00jrvhzwihkxhk7ZRg7wZRVzdR~zc8aA-NPJrzCuRkToohdW4EoSmS~~Ih4xN1VhqnyrO4WzYfTvNlvnjf-H4bnyB0b~sjCu8yNT23UNXQEWRRHb-ts-Mff5IkKLmZLe6aK7RVaLxziYNSGG514GfjoCc4FE1QlJ9xr3ZautFIBgqBpskUDGQ__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4";
export const citybankPng =
  "https://s3-alpha-sig.figma.com/img/1a3e/8c16/6efb42f0852d61acb0edd88e11f8cd4b?Expires=1698624000&Signature=WrRm9AkmUd6u00Ja~HnQNSymsgSPymTGRxo9vSbD7SvCrbntQYq58BBwjfg5CgIyl84srJSAQSQ6OeTB13MuZBvH2knFJymQ7SvkY6kw0y160vtPZmiHX~ZYqxM3-wD9XhPFDxaVwFGb2T259S5viSCG8PB9UvZTQRb5DWHy4-89C4h11Lh59tfIOOIlJtRiRhW6m0gazsLk-A8VWVdaKclWOQsVOEQq6vK4Pv8QXe7~ZCSfz-GXp~~lOLGVZORVE2PJF8LCeLW-KegBnTYuinW4qKvM5L5ttMOLO04vekO36WtYtWm~9PAt8RbU4fmWL6q2DZ68IBlujIqle1ZyzQ__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4";
export const emiPng =
  "https://s3-alpha-sig.figma.com/img/5767/b88a/af733276f38bd8a9a89df4afbffcd389?Expires=1698624000&Signature=f7ZG1sfy~exVCx8A9JEvZmLQBkSvKROmK7NWLYtV3~Bdu5xs46ju47FHRVINBUE1z~t7etZO7DHC~NRFt7lihoSJur8qy~v734TtM3H~lQ9uUG1e3RGrhNB~n~GJbHp7rhnaOkSbCTtKLf2d243UMVza0g4pJIxvbCw3BFPCFR0zf-bQa2Ln2eit9C5Z8ziHOJck8Jd-nD2cqhP6LkadniBbRqTUkF4jYbgeGulN-Q7D0mjjxfy91GZPfilFB0mkuYXa-Nvxwc53hUn~DyzG-G5d0DnREBq9VWnsA7wNlZdz1xL4Euheb5p2Eugcc1h7d7GO6JjpOyBLFUggNTdV5Q__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4";

export const giftCardPng = giftbox.src;
export const umbrallaPng =
  "https://s3-alpha-sig.figma.com/img/2816/7253/53a64f38c2a0322b5aedf6c1dc687745?Expires=1698019200&Signature=lSWVflN44kUaEhfGO5Y8AJJRU6~Xab6prxDirgpNEdXlgpIqVV8OABtVcF3ZHDBzhcMqiZyAav1VU34y2fjwEYU3gLVdyYr4NSEbNm0JYhd72ZwYEe~Hw2sbETgLaNeW9-Kppd1trWb1o8pka5a6OCYmDiILP~Dz50vlf6MFwlzi8I3EgShHPIXUcOT32zABlA2jF7tVmJmMjFbA7Dqh--91k~SfOHCtSsWxhHU6F8uu~U3-0d6nxKhzI9Tjla4V4iR5h3UFcw~rEYv3WqfukK9randB-CbypCStwPpYWH65xdekDknEVXBA9fnj7jqgQaEQG3SVxSEx2BFZKOOkAA__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4";
export const powerBankPng =
  "https://s3-alpha-sig.figma.com/img/297d/d9a0/f10bb809c230a7c4d830edd16a225d0f?Expires=1698019200&Signature=TZhav7BighXeJpEVVbs0DKx1wikFtlBG9r6XjbA1tYuFcG-8BcLzImVEthBUMzpc5PRZ4xarCRbA4yk7Jg420n2GzS~tZKNZPALeOhvDYycSdtCdWdZzMQwnHawFfT-YHPSLh5igXHTgNPvJbIyqaAgOnqauewWHkfzEkFl7~-5Yl3vhVog~aPDc4tEcR87Azma5izLzLTCoQfvCwjR86dQ6r-qFSrQ23Ky0VvhGCS3~caQ5dJ6DLrr2gWBe00WEtELqNbkEQI7o3sXt1GNEDIJzKqDahu5gpPAnY6gLNvOnTbQL19y5DfllU1oNct2oDZUKEYTpYMdDbwjE0vgLZA__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4";
export const tShirtPng =
  "https://s3-alpha-sig.figma.com/img/515e/48fb/e80a6f2f66a21590da63e4e84788f344?Expires=1698019200&Signature=HR6GtoUtS-aR6G-rVaEekHJ-IldZ26coNVz4bDviY9D5CXCLHNvnZ4fjJuvZjqbBqHA4hhp85wNWzIadJHMoe5sEurpnlpvIpSqyk8O8gbT8g1MGy~bkQqcJwEi7dmCrzWIlXES8r9znWHj~djs0~uYrLuOVFi4M2Cy~2eM6Xin7ls53fIeA1RCiM0CnJ6cuk8oFe3QAojwUw8ZtA4LG523tUZXGnL9-58dcnti8vX4nHHMbpLyd~t4TKhPJO26fzjTYrYnAxb0C0i49nYAboFQ3sJjt0Xhm7i-tuyMQa5xZ~Wj39tFgmpMRN6h-TWw3LYZdeRhkF0vzmfbYkxGDwg__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4";

export const productItems: ProductType[] = [
  {
    id: 1,
    name: 'MacBook Air 15" M2 Chip (8C CPU 10C GPU)',
    slug: "product-1",
    sku: "p1",
    thumbnail:
      "https://s3-alpha-sig.figma.com/img/070c/450c/d08de7d2a11c3d57335a749b842f2675?Expires=1697414400&Signature=Bgrj1UllAVnYj0m5j1ax8p28nPDiM8v9mH95nDQcBJ2moWWW8Tz91NuHhnR5qazOgRkHuo7VlcL0ORn~8i41JdJRI0fWYuDXsEN4mBRH6iUlCHYe9vLQGhTs2o1uzcaOBH2Joo4LEsoePy31X6fgBOa1svkaM6NiN~KgpIM1UaLtrZsdemwbeuZIrkoUU3CkXBoJA1XeXvPW2EUOmgpimwyrDwFkTeAIj-T0qGAi2nUwzbHfn0G0OBE~8rItFPRs5QCOR8Jh2jFGTL65z4BYbTEICA1pz4dE8gze6Y5sCxHdgDYnIVSbZ7qhxp0TvuOXnuOowA5MYTX6Wrq9psVBAQ__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4",
    rating: 5,
    reviewCount: 5,
    discountendPrice: 33_453,
    unit_price: 54_524,
  },
  {
    id: 2,
    name: "MacBook Air 13 inch M1 Chip",
    slug: "product-2",
    sku: "p2",
    thumbnail:
      "https://s3-alpha-sig.figma.com/img/9286/7a50/2fa62314b502b4757808cb79915120ab?Expires=1697414400&Signature=TVvfvJsG7PGBjlpuKnXCLv~kAwSHmLm~lS5-Sxy~~s4PXNugksjQ13Y4mxXwsB-QWyGmH3fCBiTVG0FA6R6hl797Z5WBICHABP9Lm0~wqW-YTy5t98jLBaiovArwXUkkWsxiTIrLd-X3~5N7n33K5RB7kkG4O1YEcsj2DHaJDwpRW45IppHHbNtCvxy5CfgN2FS1tcSs4wNucK~09WSz4l22-SF53fjv1mJQa4B4p6wlBykfcep0Y79t2Tj8QmjwdSR3ZRxzxi2k40Z8QSMJ3KtP5S8qyUvQihbh0Gb0x1EDF9ivwZbFYg-2tENS1cV~SKeWsjPUa--A9ZMX5tsOrQ__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4",
    rating: 5,
    reviewCount: 5,
    discount: 15,
    discountendPrice: 3245,
    unit_price: 45_08_025,
  },
  {
    id: 3,
    name: "Airpods Pro (2nd Generation)",
    slug: "product-3",
    sku: "p3",
    thumbnail: p3.src,
    rating: 5,
    reviewCount: 5,
    discount: 10,
    discountendPrice: 10,
    unit_price: 20,
  },
  {
    id: 4,
    name: "ONEPLUS Nord Buds 2 ANC BL Earbuds",
    slug: "product-4",
    sku: "p4",
    thumbnail: p4.src,
    rating: 5,
    reviewCount: 5,
    discountendPrice: 10,
    unit_price: 20,
  },
  {
    id: 4,
    name: "Product 5",
    slug: "product-5",
    sku: "p4",
    thumbnail: p2.src,
    rating: 5,
    reviewCount: 5,
    discountendPrice: 10,
    unit_price: 20,
  },
  {
    id: 1,
    name: "Product 1",
    slug: "product-1",
    sku: "p1",
    thumbnail:
      "https://s3-alpha-sig.figma.com/img/0117/0536/f553e0f0395b08537e66c2a111a4dded?Expires=1697414400&Signature=GzAIAHIKqOOwD8LEWtExAYD0UH2km5-rS~bI1vu7UZn6aPJ4XIKedwTRU49q-VeyFM4iVyL1UNCKWhUVMaB66ABY8TIzXe42ClPovkoTHJvd~y15x649XrltK4hr0bD0PMEAOF6RLdQqjhIu5~5cuwTgFC0GyJg7glJAyJeuwTMjQoWIjy3l1VD80bpSLBzV3R0amBuCzQXd4g8UTosFiermYDB4As7hh9wKH3d4jflAz8vH2iFoZziQIbMSf83xfup-d780L3FayVQFA7PDaVCDddnboYluNuml3Uj8n1gUeW4V4fbNx0kDbnHYY8zS6JhrbreOsRsO9T6Q45b9Eg__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4",
    rating: 5,
    reviewCount: 5,
    discountendPrice: 10,
    unit_price: 20,
  },
  {
    id: 2,
    name: "Product 2",
    slug: "product-2",
    sku: "p2",
    thumbnail: p2.src,
    rating: 5,
    reviewCount: 5,
    discountendPrice: 10,
    unit_price: 20,
  },
  {
    id: 3,
    name: "Product 3",
    slug: "product-3",
    sku: "p3",
    thumbnail: p5.src,
    rating: 5,
    reviewCount: 5,
    discountendPrice: 10,
    unit_price: 20,
  },
  {
    id: 4,
    name: "Product 4",
    slug: "product-4",
    sku: "p4",
    thumbnail: p4.src,
    rating: 5,
    reviewCount: 5,
    discountendPrice: 120000,
    unit_price: 200000,
  },
  {
    id: 4,
    name: "Product 5",
    slug: "product-5",
    sku: "p4",
    thumbnail: p5.src,
    rating: 5,
    reviewCount: 5,
    discountendPrice: 100000,
    unit_price: 2020000,
  },
];

export const banners: ImageType[] = [
  {
    image: banner1.src,
    title: "Banner 1",
  },
  {
    image: banner2.src,
    title: "Banner 2",
  },
  {
    image: banner3.src,
    title: "Banner 3",
  },
  {
    image: banner4.src,
    title: "Banner 4",
  },
];

export const brands: ImageType[] = [
  {
    image: brand1.src,
    title: "Brand 1",
  },
  {
    image: brand2.src,
    title: "Brand 2",
  },
  {
    image: brand3.src,
    title: "Brand 3",
  },
  {
    image: brand4.src,
    title: "Brand 4",
  },
  {
    image: brand5.src,
    title: "Brand 5",
  },
  {
    image: brand6.src,
    title: "Brand 6",
  },
  {
    image: brand7.src,
    title: "Brand 7",
  },
];

export const brandFilterItems: SectionFilterItem[] = [
  {
    id: 1,
    name: "Apple",
    logo: brand1.src,
  },
  {
    id: 2,
    name: "Xiomi",
    logo: brand2.src,
  },
  {
    id: 3,
    name: "OnePlus",
    logo: brand3.src,
  },
  {
    id: 4,
    name: "EDIFIER",
    logo: brand4.src,
  },
  {
    id: 1,
    name: "Apple",
    logo: brand1.src,
  },
  {
    id: 2,
    name: "Xiomi",
    logo: brand2.src,
  },
  {
    id: 3,
    name: "OnePlus",
    logo: brand3.src,
  },
  {
    id: 4,
    name: "EDIFIER",
    logo: brand4.src,
  },
  {
    id: 1,
    name: "Apple",
    logo: brand1.src,
  },
  {
    id: 2,
    name: "Xiomi",
    logo: brand2.src,
  },
  {
    id: 3,
    name: "OnePlus",
    logo: brand3.src,
  },
  {
    id: 4,
    name: "EDIFIER",
    logo: brand4.src,
  },
  {
    id: 1,
    name: "Apple",
    logo: brand1.src,
  },
  {
    id: 2,
    name: "Xiomi",
    logo: brand2.src,
  },
  {
    id: 3,
    name: "OnePlus",
    logo: brand3.src,
  },
  {
    id: 4,
    name: "EDIFIER",
    logo: brand4.src,
  },
];

export const htmlContent = `
<h3>What Is Meant By Lorem Ipsum In Website?</h3>
<p>The word Lorem Ipsum is derived from the Latin word which means &ldquo;pain itself&rdquo;. It is a kind of a text filler tool that is used by the webmaster on the website.</p>
<p>Basically, this tool is used to create dummy content on the website when it&rsquo;s new.</p>
<h3>Why Lorem Ipsum Is Used?</h3>
<p>It helps the designer plan where the content will sit. It helps in creating drafts of the content on the pages of the website. It originates from the Latin text but is seen as gibberish.</p>
<p>Sometimes, the reader gets distracted while creating or working on the website. That&rsquo;s why this language is important.</p>
<p>This tool makes the work easier for the webmaster.</p>
<h3>How Lorem Ipsum Can Be Used?</h3>
<p>When using Lorem Ipsum for creating dummy content for your newly created website, you can select the text formats you want from the tool. Like, words, sentences, or paragraphs. Then, you can select whether you want HTML markup in your dummy content or not Then, you can choose the number of words and paragraphs for your dummy content and execute the plan accordingly. You can use this tool at incrementors.com for free.</p>
<h3>How Can I Use Lorem Ipsum Tool For My Website?</h3>
<p>You can click on the &lsquo;item to generate&rsquo; column and select the format you want content in. Below that, you can select if you want an HTML tag in your content or not After that, you can choose how many paragraphs you want in the &lsquo;how many items to generate&rsquo; column. Then, you can choose the minimum and maximum words you want per sentence. Later, you can select the minimum and maximum sentences you want per paragraph. Finally, click on the button &lsquo;generate&rsquo; <br>Taddalaa! <br>You got your Lorem Ipsum content for your website.</p>
`;

export const productDescription = `
<h2 dir="ltr"><strong>iPhone 14 Pro Price in Bangladesh - Apple's Latest Flagship Smartphone</strong></h2>
<p dir="ltr">iPhone 14 Pro is the best phone to get if you want a complete package in a compact formula. It does so many things right. It brings all the latest and high-end features from its bigger brother without burning a hole in your pocket.</p>
<h3 dir="ltr"><strong>Key benefits at a glance</strong></h3>
<ul>
<li dir="ltr">
<p dir="ltr">The compact design makes it perfect for one-hand use</p>
</li>
<li dir="ltr">
<p dir="ltr">Powerful A16 bionic chip provides industry-leading performance no matter what you are doing</p>
</li>
<li dir="ltr">
<p dir="ltr">Max 1TB storage options give you enough room to store your favourite photos and videos</p>
</li>
<li dir="ltr">
<p dir="ltr">Professional-grade triple-camera systems offer a more creative perspective to shooting photos and videos</p>
</li>
<li dir="ltr">
<p dir="ltr">IP68 rating makes sure your precious iPhone is safe from dust and water</p>
</li>
<li dir="ltr">
<p dir="ltr">Excellent battery life for a small-sized iPhone</p>
</li>
<li dir="ltr">
<p dir="ltr">Available in six colours, meaning you have more options to choose from according to your taste</p>
</li>
</ul>
<h3 dir="ltr"><strong>Same familiar design with a twist</strong></h3>
<p dir="ltr">Design-wise iPhone 14 Pro looks a lot like iPhone 13 Pro. From the back, it&rsquo;s tough to distinguish between these devices other than the slightly bigger camera bump.</p>
<p dir="ltr">However, flip on the other side, and you will see a noticeable change. The notch is gone, and iPhone 14 Pro features a new Dynamic Island.</p>
<p dir="ltr">iPhone 14 Pro has four colour options: Space Black, Silver, Gold, and everyone&rsquo;s favourite, Deep Purple.</p>
<h3 dir="ltr"><strong>Introducing Dynamic Island: An innovative new way to interact with your iPhone</strong></h3>
<p dir="ltr">This year&rsquo;s iPhone 14 Pro&rsquo;s main attraction was the new Dynamic Island. It&rsquo;s a pill shape cutout significantly smaller than the previous notch.</p>
<p dir="ltr">This new feature interactively shows notifications and many system alerts. It acts like a mini dashboard where you can see incoming calls, messages, etc. You can also control music from it without closing your existing app.</p>
<h3 dir="ltr"><strong>The display got even better</strong></h3>
<p dir="ltr">iPhone 14 Pro comes with a 6.1-inch OLED display. The resolution is 2556x1179, and the pixel density is 460 ppi.</p>
<p dir="ltr">The max brightness of the iPhone 14 Pro&rsquo;s display is 1000 nits in a typical situation. It cranks up to a maximum of 1600 nits brightness when playing HDR videos and 2000 nits in harsh light.</p>
<p dir="ltr">The screen is also equipped with adaptive refresh rates that can go 1Hz to 120Hz, depending on what is happening on the screen.</p>
<p dir="ltr">This technology helps save battery life. Because of this feature, iPhone 14 Pro now has the Always-On Display feature. In addition, iPhone 14 Pro supports True Tone and Wide Color (P3).</p>
<ul>
<li dir="ltr">
<p dir="ltr">Ceramic Shield glass offers four times more protection</p>
</li>
<li dir="ltr">
<p dir="ltr">A 6.1-inch sharp and bright OLED display is perfect for watching social media videos</p>
</li>
<li dir="ltr">
<p dir="ltr">Variable refresh rate saves battery</p>
</li>
<li dir="ltr">
<p dir="ltr">Always on display makes it easy to see important notifications</p>
</li>
<li dir="ltr">
<p dir="ltr">Increased brightness helps you see the screen at outdoors without an issue</p>
</li>
</ul>
<h3 dir="ltr"><strong>What&rsquo;s under the hood?</strong></h3>
<p dir="ltr">iPhone 14 Pro packs Apple&rsquo;s newest and most powerful A16 Bionic chip. Apple made this chip using a 4nm fabrication. The chip has a 6‑core CPU (2 performance+4 efficiency) and a 5‑core GPU.</p>
<p dir="ltr">Moreover, iPhone 14 Pro has 6GB RAM and supports up to 1TB NVMe SSD. The performance is impressive on the iPhone 14 Pro. It can easily handle any resource-intensive task without breaking a sweat.</p>
<p dir="ltr">It is also excellent for gaming and handling daily tasks. You will not face any lags with this device.</p>
<ul>
<li dir="ltr">
<p dir="ltr">Fastest mobile chip perfect for gaming and any demanding task&nbsp;&nbsp;</p>
</li>
<li dir="ltr">
<p dir="ltr">6GB RAM and a maximum 1TB storage option make iPhone 14 Pro future-proof for at least five years</p>
</li>
</ul>
<h3 dir="ltr"><strong>A massive upgrade on the camera</strong></h3>
<p dir="ltr">iPhone 14 Pro sees a considerable upgrade on the camera front too! It is equipped with a massive 48MP primary sensor.</p>
<p dir="ltr">The primary sensor uses pixel-binning technology and merges it into a 12MP image. You will also find a new 2x zoom option inside the camera, which uses the primary camera to crop in.</p>
<p dir="ltr">Aside from that, it boasts an improved 12MP Ultra Wide and a 3x Telephoto lens along with the primary camera in the back.</p>
<p dir="ltr">Overall, all the cameras on iPhone 14 Pro have been upgraded and offer better low-light performance.</p>
<ul>
<li dir="ltr">
<p dir="ltr">The main 48MP camera can capture high-resolution images with better details</p>
</li>
<li dir="ltr">
<p dir="ltr">Telephoto and Ultrawide cameras offer better low-light performance</p>
</li>
<li dir="ltr">
<p dir="ltr">The resolution of the cinematic video mode is increased from Full HD to up to 4K</p>
</li>
<li dir="ltr">
<p dir="ltr">A new action mode helps to take super steady videos even while running</p>
</li>
</ul>
<p><img src="https://s3-alpha-sig.figma.com/img/451a/1a06/a99b28d4d1ec5a5333775478ba87f600?Expires=1695600000&amp;Signature=ZebHiIigCtu5aWRASnnankyu-~3pvJ1C49vtWkK3cG1oWSOvNa11MjQHqzbRApSUpI7xQb-7vAjfYn49VT7lmsnFg4MjBxC4nMZofZs~3skmUC22EKeyvyXfro~sOYHON3HaW8EZo8ejw2QyRrR2VBhXPpK1dOYXTE626JKHllIPtIhsd8QddauDjpECiNWlaKdMFz0ryM7CdCYN3LfGSlQiP6AwHl7wuYZa5bv31hP-iRrAgeFhLi0ipng1tTa5EJl4KM972ii6TAHdXD0V0v6XhJ-3kk18Ey7Z3FgG8ly9rro5bavhgBCI9rQZwBJC5un1-wTLP4EJuMbnhVjNlg__&amp;Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4" alt=""></p>
`;

export const productAttributes: ProductAttribute[] = [
  {
    id: 1,
    name: "Color",
    type: "color",
    options: [
      {
        id: 1,
        name: "Dark",
        value: "#393836",
      },
      {
        id: 2,
        name: "Blue",
        value: "#655B73",
      },
      {
        id: 3,
        name: "Green",
        value: "#B0EAAB",
      },
    ],
  },
  {
    id: 2,
    name: "ROM",
    options: [
      {
        id: 1,
        name: "64GB",
        value: "64",
      },
      {
        id: 2,
        name: "128GB",
        value: "128",
      },
      {
        id: 3,
        name: "256GB",
        value: "256",
      },
    ],
  },
  {
    id: 3,
    name: "RAM",
    options: [
      {
        id: 1,
        name: "4GB",
        value: "4",
      },
      {
        id: 2,
        name: "8GB",
        value: "8",
      },
      {
        id: 3,
        name: "16GB",
        value: "16",
      },
    ],
  },
];

export const addressData: AddressType[] = [
  {
    id: 1,
    name: "John Doe",
    address: "123 Main St, New York, NY 10030",
    phone: "123-456-7890",
    country: "Bangladesh",
    city: "Dhaka",
  },
  {
    id: 2,
    name: "Mark Doe",
    address: "123 Main St, New York, NY 10030",
    phone: "123-456-7890",
    country: "Bangladesh",
    city: "Dhaka",
  },
  {
    id: 3,
    name: "Sam Smith",
    address: "123 Main St, New York, NY 10030",
    phone: "123-456-7890",
    country: "Bangladesh",
    city: "Dhaka",
  },
  {
    id: 1,
    name: "John Doe",
    address: "123 Main St, New York, NY 10030",
    phone: "123-456-7890",
    country: "Bangladesh",
    city: "Dhaka",
  },
  {
    id: 2,
    name: "Mark Doe",
    address: "123 Main St, New York, NY 10030",
    phone: "123-456-7890",
    country: "Bangladesh",
    city: "Dhaka",
  },
  {
    id: 3,
    name: "Sam Smith",
    address: "123 Main St, New York, NY 10030",
    phone: "123-456-7890",
    country: "Bangladesh",
    city: "Dhaka",
  },
];

export const giftItems: ProductGift[] = [
  {
    id: 1,
    name: "BMW Umbrella x 1",
    thumbnail: umbrallaPng,
  },
  {
    id: 2,
    name: "Anker Power Bank x 1",
    thumbnail: powerBankPng,
  },
  {
    id: 3,
    name: "Arctech T shirt x 1",
    thumbnail: tShirtPng,
  },
];

// distance (meters) used to offset store-locator map markers
// (lives here instead of containers/StoreLocator so server code can import it)
export const markerYOffset = 500;

// predefined EMI tenor options for the admin offer-logic form
export const emiTenors: EMITenor[] = [
  { name: "3 Months", percent: 0 },
  { name: "6 Months", percent: 0 },
  { name: "9 Months", percent: 0 },
  { name: "12 Months", percent: 0 },
  { name: "18 Months", percent: 0 },
  { name: "24 Months", percent: 0 },
  { name: "36 Months", percent: 0 },
];
